module.exports = __webpack_public_path__ + "img/Risorsa 10.fa29be4e.png";